var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCleanCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 240,
    viewBox: "0 0 350 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M147.28 143.11L120.05 125.54V117.98L147.28 100.41V110.49L129.15 121.62V121.9L147.28 133.03V143.11ZM202.665 143.11V133.03L220.795 121.9V121.62L202.665 110.49V100.41L229.895 117.98V125.54L202.665 143.11Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M181 101L169 145",
    stroke: "currentColor",
    strokeWidth: 8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7938 68.4801L72 45.2169L83.2062 68.4802C83.6781 69.4599 84.4567 70.2591 85.4238 70.7565L108.255 82.5L85.4238 94.2435C84.4567 94.7409 83.6781 95.5401 83.2062 96.5199L72 119.783L60.7938 96.5198C60.3219 95.5401 59.5433 94.7409 58.5762 94.2435L35.7451 82.5L58.5762 70.7565C59.5433 70.2591 60.3219 69.4599 60.7938 68.4801Z",
    stroke: "currentColor",
    strokeWidth: 8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M287.112 136.466L293.5 123.213L299.888 136.466C300.36 137.446 301.138 138.245 302.106 138.742L315.251 145.5L302.106 152.258C301.138 152.755 300.36 153.554 299.888 154.534L293.5 167.787L287.112 154.534C286.64 153.554 285.862 152.755 284.894 152.258L271.749 145.5L284.894 138.742C285.862 138.245 286.64 137.446 287.112 136.466Z",
    stroke: "currentColor",
    strokeWidth: 8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M81.7776 165.119L86.5 155.26L91.2224 165.119C91.6921 166.099 92.4687 166.9 93.4345 167.4L103.294 172.5L93.4345 177.6C92.4687 178.1 91.6921 178.901 91.2224 179.881L86.5 189.74L81.7776 179.881C81.3079 178.901 80.5313 178.1 79.5655 177.6L69.7059 172.5L79.5655 167.4C80.5313 166.9 81.3079 166.099 81.7776 165.119Z",
    stroke: "currentColor",
    strokeWidth: 8
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M242.457 64.1325L251.5 45.2577L260.543 64.1325C261.013 65.1131 261.789 65.9138 262.755 66.4133L281.292 76L262.755 85.5867C261.789 86.0862 261.013 86.8869 260.543 87.8675L251.5 106.742L242.457 87.8675C241.987 86.8869 241.211 86.0862 240.245 85.5867L221.708 76L240.245 66.4133C241.211 65.9138 241.987 65.1131 242.457 64.1325Z",
    stroke: "currentColor",
    strokeWidth: 8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCleanCode);
export default __webpack_public_path__ + "static/media/clean_code.bef4fdab7d375f1cf0eaadfd7e81ac82.svg";
export { ForwardRef as ReactComponent };